import * as React from 'react';
import { AlertIcon } from './Icons';
import { PageRoutes } from '../root/Routes';
import { injectBillingPeriod, BillingPeriodInjectorProperties } from '../hocs/BillingPeriodInjector';

const paymentIssueStatuses = ['past_due', 'unpaid'];

interface SubscriptionStatusAlertProperties extends BillingPeriodInjectorProperties {
    history?: any;
    isPaymentReferenceTextDisabled?: boolean;
}

class SubscriptionStatusAlert extends React.Component<SubscriptionStatusAlertProperties> {
    constructor(props: SubscriptionStatusAlertProperties) {
        super(props);

        this.handlePaymentClick = this.handlePaymentClick.bind(this);
    }

    render() {
        let paymentReferenceText: JSX.Element | null = null;
        if (this.props.isPaymentReferenceTextDisabled !== true) {
            paymentReferenceText = <React.Fragment>review the <a href="#" onClick={this.handlePaymentClick}>Billing section</a> and </React.Fragment>;
        }

        const alert = (
            <div className="alert alert-default" role="alert">
                <AlertIcon width="21px" height="18px" />
                <p>
                    There is an issue with the payment of your subscription. Please, {paymentReferenceText}make sure your billing details are accurate.
                </p>
            </div>
        );

        if (!paymentIssueStatuses.includes(this.props.billingPeriod.subscriptionStatus)) {
            return null;
        }

        return alert;
    }

    private handlePaymentClick(e: React.MouseEvent<HTMLAnchorElement>) {
        e.preventDefault();
        if (this.props.history) {
            this.props.history.push(PageRoutes.Billing);
        }
    }
}

export default injectBillingPeriod(SubscriptionStatusAlert);



// WEBPACK FOOTER //
// ./src/webportal/components/common/SubscriptionStatusAlert.tsx